import { ThemeProvider, ThemeStyles } from "@bonusx-global/bx-design-system";
import StyledEngineProvider from "@mui/material/StyledEngineProvider";
import { OpenFeatureProvider } from "@openfeature/react-sdk";
import { Provider as JotaiProvider } from "jotai";
import React from "react";
import { Provider } from "react-redux";
import { ChatbotProvider } from "../legacy/components/Chatbot/contexts/chatbot-provider";
import { InitializeApp } from "../legacy/components/initialize-app/initialize-app";
import SuspenseWrapper from "../legacy/components/SuspenseWrapper";
import { WindowBeforeUnload } from "../legacy/components/WindowBeforeUnload";
import { ErrorHttpProvider } from "../legacy/contexts/ErrorHttpContext/providers/ErrorHttpProvider";
import { ClientConstantsProvider } from "../legacy/services/client-constants/provider/client-constants-provider";
import citizenTheme from "../legacy/styles/citizenTheme";
import { QueryClientProvider } from "../lib/tankstack/providers/QueryClientProvider";
import { globalStore } from "../stores/global.store";
import store from "./store/store";

interface ProvideEssentialsProps {
  readonly children: React.ReactNode;
}

export function ProvideEssentials({ children }: ProvideEssentialsProps) {
  return (
    <Provider store={store}>
      <JotaiProvider store={globalStore}>
        <QueryClientProvider>
          <SuspenseWrapper>
            <OpenFeatureProvider suspend={false}>
              <ClientConstantsProvider>
                <ErrorHttpProvider>
                  <ChatbotProvider>
                    <InitializeApp />
                    <WindowBeforeUnload />
                    <StyledEngineProvider injectFirst>
                      <ThemeProvider theme={citizenTheme}>
                        <ThemeStyles />
                        {children}
                      </ThemeProvider>
                    </StyledEngineProvider>
                  </ChatbotProvider>
                </ErrorHttpProvider>
              </ClientConstantsProvider>
            </OpenFeatureProvider>
          </SuspenseWrapper>
        </QueryClientProvider>
      </JotaiProvider>
    </Provider>
  );
}
